import { fetchConToken } from "../helpers/fetch";
import { armarParametrosAutorizaciones, armarParametrosBuscadorAutorizaciones, armarParametrosBuscadorPresupuestos, armarParametrosDatosModificacionInternacion, armarParametrosPresupuestos } from "../helpers/parametros";

const AutorizacionesService = {
  getTiposSolicitudes: () => {
    return fetchConToken(`TiposSolicitud`);
  },
  getSolicitudes: (idAfiliado) => {
    return fetchConToken(`Solicitudes/traerPorAfiliado/${idAfiliado}`);
  },
  getSolicitudesAfiliadoHce: (idAfiliado) => {
    return fetchConToken(`Solicitudes/traerPorAfiliadoHce/${idAfiliado}`);
  },
  getSolicitudesAuditoria: (
    idAfiliado,
    idEfectorFacturacion,
    idBandeja,
    idSolicitud,
    idSeccional,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacionPrestador,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    rolIngresoInterDom,
    rolIngresoAutorizaciones,
    idTipoSolicitud,
    page,
    pageSize,
    rolIngresoOxigeno
  ) => {
    return fetchConToken(
      `Solicitudes/traerAuditoria?${armarParametrosAutorizaciones(
        idAfiliado,
        idEfectorFacturacion,
        idBandeja === 0 ? null : idBandeja,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        null,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacionPrestador,
        rolIngresoInterDom,
        idSolicitud,
        rolIngresoAutorizaciones,
        idTipoSolicitud === 0 ? null : idTipoSolicitud,
        idSeccional === 0 ? null : idSeccional,
        page,
        pageSize,
        rolIngresoOxigeno
      )}`
    );
  },
  getContadoresSolicitudesAuditoria: (
    idAfiliado,
    idEfectorFacturacion,
    idBandeja,
    idSolicitud,
    idSeccional,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacionPrestador,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    rolIngresoInterDom,
    rolIngresoAutorizaciones,
    idTipoSolicitud,
    rolIngresoOxigeno) => {
    return fetchConToken(
      `Solicitudes/traerContadoresAuditoriaUsuario?${armarParametrosAutorizaciones(
        idAfiliado,
        idEfectorFacturacion,
        idBandeja === 0 ? null : idBandeja,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        null,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacionPrestador,
        rolIngresoInterDom,
        idSolicitud,
        rolIngresoAutorizaciones,
        idTipoSolicitud === 0 ? null : idTipoSolicitud,
        idSeccional === 0 ? null : idSeccional,
        rolIngresoOxigeno
      )}`
    );
  },
  getExcelConsultaAuditoria: (
    idAfiliado,
    idEfectorFacturacion,
    idBandeja,
    idSolicitud,
    idSeccional,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacionPrestador,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    idTipoSolicitud
  ) => {
    return fetchConToken(
      `Solicitudes/generarExcelInternacion?${armarParametrosAutorizaciones(
        idAfiliado,
        idEfectorFacturacion,
        idBandeja,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        null,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacionPrestador,
        null,
        idSolicitud,
        null,
        null,
        idSeccional
      )}`
    );
  },
  getExcelConsultaPresupuesto: (
    idAfiliado,
    idPresupuesto,
    fechaDesde,
    fechaHasta,
    idEstadoPresupuesto,
    rolIngresoAutorizaciones,
    idSeccional,
    idBandeja,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacion
  ) => {
    return fetchConToken(
      `Presupuestos/generarExcelPresupuestos?${armarParametrosPresupuestos(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
        idEstadoPresupuesto,
        rolIngresoAutorizaciones,
        idSeccional,
        idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion
      )}`
    );
  },
  getEfectorFacturacionSinContrato: (idPresupuesto) => {
    return fetchConToken(`Presupuestos/traerContratoCreadoPorPresupuesto/${idPresupuesto}`)
  },
  getTraerPorIdSolicitud: (idSolicitud, idEstadoSolicitud) => {
    return fetchConToken(`Solicitudes/traerPorIdSolicitud/${idSolicitud}/${idEstadoSolicitud}`)
  },
  validarDenunciaInt: (idSolicitud, idAfiliado) => {
    return fetchConToken(`Solicitudes/validarDenunciaInternacion/${idSolicitud}/${idAfiliado}`)
  },
  postSolicitud: (data) => {
    return fetchConToken(`Solicitudes`, data, "POST");
  },
  putSolicitud: (data) => {
    return fetchConToken(`Solicitudes`, data, "PUT");
  },
  putValorCierre: (data) => {
    return fetchConToken(`Solicitudes/setearValorCierre`, data, "PUT");
  },
  putCancelarSolicitud: (data) => {
    return fetchConToken(`Solicitudes/cancelarSolicitud`, data, "PUT");
  },
  getEfector: (data, tipo) => {
    return fetchConToken(
      `${tipo === "profesional"
        ? "Prestadores/traerParaAutorizacion"
        : "EfectorFacturacion/traerEfectorSolicitudAutorizacion"
      }?&codPractica=${data.codigoPractica}${data.idTipoSolicitud ? "&idTipoSolicitud=" + data.idTipoSolicitud : ""
      }${data.fechaProgramada ? "&fechaProgramada=" + data.fechaProgramada : ""
      }${data.nombre ? "&nombre=" + data.nombre : ""
      }${data.idLocalidad ? "&idLocalidad=" + data.idLocalidad : ""
      }${data.idZona ? "&idZona=" + data.idZona : ""
      }${"&conInternacion=" + data.conInternacion
      }`
    );
  },
  getEfectorLaboratorio: (data) => {
    return fetchConToken(
      `${"EfectorFacturacion/traerEfectorSolicitudLaboratorio"
      }?&idSolicitud=${data.idSolicitud
      }${data.nombre ? "&nombre=" + data.nombre : ""
      }${data.idLocalidad ? "&idLocalidad=" + data.idLocalidad : ""
      }${data.idZona ? "&idZona=" + data.idZona : ""
      }`
    );
  },
  getLocalidadesPorZona: (idZona) => {
    return fetchConToken(`Localidades/traerPorZona/${idZona}`);
  },
  getLocalidadesPorZonaSegunPractica: (idZona, idPractica, conInternacion) => {
    return fetchConToken(`Localidades/traerPorZonaSegunPractica/${idZona}/${idPractica}/${conInternacion}`);
  },
  getPrescriptores: (texto) => {
    return fetchConToken(`Prescriptores/Busqueda?texto=${texto}`);
  },
  postPrescriptor: (prescriptor) => {
    return fetchConToken(`Prescriptores`, prescriptor, "POST");
  },
  //TIPO DOCUMENTACION SOLICITUD
  getTiposDocumentacionSolicitud: () => {
    return fetchConToken(`TiposDocumentacionSolicitud`);
  },
  getTiposDocumentacionSolicitudPorTipoSolicitud: (idTipoSolicitud) => {
    return fetchConToken(`TiposDocumentacionSolicitud/${idTipoSolicitud}`);
  },
  getTiposDocumentacionModalFinalizar: (idTipoSolicitud) => {
    return fetchConToken(`TiposDocumentacionSolicitud/ParaModalFinalizar/${idTipoSolicitud}`);
  },
  postTiposDocumentacion: (data) => {
    return fetchConToken(`TiposDocumentacionSolicitud`, data, "POST");
  },
  putTiposDocumentacion: (IdTipoDocSolicitud, data) => {
    return fetchConToken(`TiposDocumentacionSolicitud/${IdTipoDocSolicitud}`, data, "PUT");
  },
  deleteTiposDocumentacion: (IdTipoDocSolicitud) => {
    return fetchConToken(`TiposDocumentacionSolicitud/${IdTipoDocSolicitud}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACION PRACTICA SOLICITUD
  getTiposDocumentacionPracticaSolicitud: () => {
    return fetchConToken(`TiposDocumentacionPracticaSolicitud`);
  },
  postTiposDocumentacionPracticaSolicitud: (data) => {
    return fetchConToken(`TiposDocumentacionPracticaSolicitud`, data, "POST");
  },
  putTiposDocumentacionPracticaSolicitud: (IdTipoDocPracticaSolicitud, data) => {
    return fetchConToken(`TiposDocumentacionPracticaSolicitud/${IdTipoDocPracticaSolicitud}`, data, "PUT");
  },
  deleteTiposDocumentacionPracticaSolicitud: (IdTipoDocPracticaSolicitud) => {
    return fetchConToken(`TiposDocumentacionPracticaSolicitud/${IdTipoDocPracticaSolicitud}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACION PRESUPUESTO
  getTiposDocumentacionPresupuesto: () => {
    return fetchConToken(`TiposDocumentacionPresupuesto`);
  },
  getTiposDocumentacionRecupero: () => {
    return fetchConToken(`TiposDocumentacionRecupero`);
  },
  postTiposDocumentacionPresupuesto: (data) => {
    return fetchConToken(`TiposDocumentacionPresupuesto`, data, "POST");
  },
  postTiposDocumentacionRecupero: (data) => {
    return fetchConToken(`TiposDocumentacionRecupero`, data, "POST");
  },
  putTiposDocumentacionPresupuesto: (IdDocumentacionPresupuesto, data) => {
    return fetchConToken(`TiposDocumentacionPresupuesto/${IdDocumentacionPresupuesto}`, data, "PUT");
  },
  putTiposDocumentacionRecupero: (IdDocumentacionRecupero, data) => {
    return fetchConToken(`TiposDocumentacionRecupero/${IdDocumentacionRecupero}`, data, "PUT");
  },
  deleteTiposDocumentacionPresupuesto: (IdDocumentacionPresupuesto) => {
    return fetchConToken(`TiposDocumentacionPresupuesto/${IdDocumentacionPresupuesto}`, {}, "DELETE");
  },
  deleteTiposDocumentacionRecupero: (IdDocumentacionRecupero) => {
    return fetchConToken(`TiposDocumentacionRecupero/${IdDocumentacionRecupero}`, {}, "DELETE");
  },
  //TIPO DOCUMENTACIONES
  getTiposDocu: () => {
    return fetchConToken(`TiposDocumentacion`);
  },
  postTiposDocu: (data) => {
    return fetchConToken(`TiposDocumentacion`, data, "POST");
  },
  putTiposDocu: (idTipoDoc, data) => {
    return fetchConToken(`TiposDocumentacion/${idTipoDoc}`, data, "PUT");
  },
  deleteTiposDocu: (idTipoDoc) => {
    return fetchConToken(`TiposDocumentacion/${idTipoDoc}`, {}, "DELETE");
  },
  //DOCUMENTACION PRESUPUESTO
  getDocumentacionPresupuesto: (idPresupuesto) => {
    return fetchConToken(`DocumentacionPresupuesto/${idPresupuesto}`);
  },
  deleteDocumentacionPresupuesto: (idDocumento) => {
    return fetchConToken(
      `DocumentacionPresupuesto/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //DOCUMENTACION RECUPERO
  getDocumentacionRecupero: (idRecupero) => {
    return fetchConToken(`DocumentacionRecupero/${idRecupero}`);
  },
  deleteDocumentacionRecupero: (idDocumento) => {
    return fetchConToken(
      `DocumentacionRecupero/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //DOCUMENTACION PRACTICA SOLICITUD
  getDocumentacionPracticaSolicitud: (idSolicitud) => {
    return fetchConToken(`DocumentacionPracticaSolicitud/${idSolicitud}`);
  },
  deleteDocumentacionPracticaSolicitud: (idDocumento) => {
    return fetchConToken(
      `DocumentacionPracticaSolicitud/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //DOCUMENTACION SOLICITUD
  getDocumentacionSolicitud: (idSolicitud) => {
    return fetchConToken(`DocumentacionSolicitudes/${idSolicitud}`);
  },
  deleteDocumentacionSolicitud: (idDocumento) => {
    return fetchConToken(
      `DocumentacionSolicitudes/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //SOLICITUD
  postPracticas: (practicas) => {
    return fetchConToken(`PracticasSolicitud`, practicas, "POST");
  },
  postPracticasPendientesDenuncia: (data) => {
    return fetchConToken(`PracticasSolicitud/pendientesDenuncia`, data, "POST");
  },
  postPracticasAutorizadasDenuncia: (data) => {
    return fetchConToken(`PracticasSolicitud/autorizadasDenuncia`, data, "POST");
  },
  postEfectorLaboratorio: (data) => {
    return fetchConToken(`PracticasSolicitud/editarEfectorLaboratorio`, data, "POST");
  },
  postEnviarSolicitud: (idSolicitud, urgente) => {
    return fetchConToken(
      `Solicitudes/enviar/${idSolicitud}/${urgente}`,
      {},
      "POST"
    );
  },
  postPagoCoseguro: (data) => {
    return fetchConToken(`Solicitudes/pagoCoseguro`, data, 'POST');
  },
  putCerrarInternacion: (data) => {
    return fetchConToken(`Solicitudes/cerrarInternacion`, data, 'PUT');
  },
  putCerrarInternacionDomiciliaria: (data) => {
    return fetchConToken(`Solicitudes/cerrarInternacionDomiciliaria`, data, 'PUT');
  },
  putCerrarSolicitudOxigeno: (data) => {
    return fetchConToken(`Solicitudes/cerrarOxigeno`, data, 'PUT');
  },
  getMateriales: (texto) => {
    return fetchConToken(`NomencladorProtesis/Busqueda?texto=${texto}`);
  },
  getPracticasSolicitudSeleccionada: (idSolicitud, idEstadoSolicitud, idBandeja) => {
    return fetchConToken(`PracticasSolicitud/traerPorSolicitud/${idSolicitud
      }${idEstadoSolicitud ? '?idEstadoSolicitud=' + idEstadoSolicitud : ''
      }${idBandeja > 0 ? '&idBandeja=' + idBandeja : ''}`
    )
  },
  getPracticasDenunciaOrigen: (idSolicitud, idEstadoSolicitud, idBandeja) => {
    return fetchConToken(`PracticasSolicitud/traerDenunciaOrigen/${idSolicitud
      }${idEstadoSolicitud ? '?idEstadoSolicitud=' + idEstadoSolicitud : ''
      }${idBandeja > 0 ? '&idBandeja=' + idBandeja : ''}`
    )
  },
  getSolicitudesRelacionadas: (idSolicitud) => {
    return fetchConToken(`Solicitudes/traerSolicitudesRelacionadas/${idSolicitud}`)
  },
  putEstadoSolicitud: (data) => {
    return fetchConToken(`Solicitudes/modificarEstado`, data, "PUT");
  },
  getTrackingSolicitud: (idSolicitud) => {
    return fetchConToken(
      `TrackingSolicitudes/traerPorSolicitud/${idSolicitud}`
    );
  },
  getTrackingPresupuesto: (idPresupuesto) => {
    return fetchConToken(
      `TrackingPresupuestos/traerPorPresupuesto/${idPresupuesto}`
    );
  },
  getSectoresInternacion: () => {
    return fetchConToken(`SectoresInternacion`);
  },
  getEfectorDenunciaInternacion: (idTipoSolicitud, nombre = "") => {
    return fetchConToken(
      `EfectorFacturacion/traerEfectorSolicitudAutorizacion?nombre=${nombre}&idTipoSolicitud=${idTipoSolicitud}`
    );
  },
  putEfectorDenunciaInternacion: (data) => {
    return fetchConToken(
      `CartillaPrestadores/modificarAuditoriaTerreno`,
      data,
      "PUT"
    );
  },
  getConsumosAfiliado: (idAfiliado) => {
    return fetchConToken(`Solicitudes/traerConsumosAfiliado/${idAfiliado}`);
  },
  getConsumosAfiliadoPresupuesto: (idAfiliado) => {
    return fetchConToken(`Presupuestos/traerConsumosAfiliado/${idAfiliado}`);
  },
  //TIPO NOTAS
  getTiposNotas: () => {
    return fetchConToken(`TiposNotaSolicitud`);
  },
  getTiposNotasTodas: () => {
    return fetchConToken(`TiposNotaSolicitud/traerTodas`);
  },
  getTiposNotasPorEstado: (idEstadoPresupuesto) => {
    return fetchConToken(`TiposNotaSolicitud/traerPorEstadoPresupuesto/${idEstadoPresupuesto}`);
  },
  //NOTAS SOLICITUD
  getNotas: (idSolicitud) => {
    return fetchConToken(`NotasSolicitud/traerPorSolicitud/${idSolicitud}`);
  },
  postNotas: (data, method) => {
    return fetchConToken(`NotasSolicitud`, data, method);
  },
  deleteNota: (data) => {
    return fetchConToken(`NotasSolicitud`, data, "DELETE");
  },
  //NOTAS PRESUPUESTO
  getTrackingNotaPresupuesto: (idPresupuesto) => {
    return fetchConToken(`TrackingNotaPresupuesto/traerPorNota/${idPresupuesto}`);
  },
  getNotasPresupuesto: (idPresupuesto) => {
    return fetchConToken(`NotasPresupuesto/traerPorPresupuesto/${idPresupuesto}`);
  },
  postNotaPresupuesto: (data, method) => {
    return fetchConToken(`NotasPresupuesto`, data, method);
  },
  deleteNotaPresupuesto: (data) => {
    return fetchConToken(`NotasPresupuesto`, data, "DELETE");
  },
  //OBSERVACIONES
  getTiposObservaciones: () => {
    return fetchConToken(`TiposObservacionAudCampo`);
  },
  getObservaciones: (idSolicitud) => {
    return fetchConToken(
      `ObservacionAudCampoSolicitud/traerPorSolicitud/${idSolicitud}`
    );
  },
  postObservacion: (data, method) => {
    return fetchConToken(`ObservacionAudCampoSolicitud`, data, method);
  },
  postTrackingObservacion: (data, method) => {
    return fetchConToken(`ObservacionAudCampoSolicitud/Tracking`, data, "POST");
  },
  //MOTIVOS CIERRE INTERNACION DOMICILIARIA
  getMotivosCierreInternacionDomiciliaria: () => {
    return fetchConToken(`MotivosCierreInterDom`);
  },
  //MOTIVOS INTERNACION
  getMotivosInternacionSolicitud: () => {
    return fetchConToken(`MotivosInternacion`);
  },
  //MOTIVOS CIERRE OXIGENO
  getMotivosCierreOxigeno: () => {
    return fetchConToken(`MotivosCierreInterDom/MotivosOxigeno`);
  },
  //BANDEJAS AUTORIZACION
  getBandejas: () => {
    return fetchConToken(`BandejasAutorizacion`);
  },
  getBandejasPorUsuario: () => {
    return fetchConToken(`BandejasAutorizacion/TraerPorUsuario`);
  },
  putBandejaSolicitud: (data) => {
    return fetchConToken(`Solicitudes/moverBandeja`, data, "PUT");
  },
  putBandejaPresupuesto: (data) => {
    return fetchConToken(`Presupuestos/moverBandeja`, data, "PUT");
  },
  putAprobarPresupuesto: (data) => {
    return fetchConToken(`Presupuestos/aprobarPresupuesto`, data, "PUT");
  },
  //RELACION PRACTICA BANDEJAS
  getNomencladorBandeja: (texto = "") => {
    return fetchConToken(`NomencladorBandeja?texto=${texto}`);
  },
  putNomencladorBandeja: (data) => {
    return fetchConToken(`NomencladorBandeja`, data, "PUT");
  },
  //PRESUPUESTOS
  getPrestadorPresupuesto: (data) => {
    return fetchConToken(`Prestadores/traerParaPresupuesto?&parametro=${data}`);
  },
  getPresupuestosGestion: (
    idAfiliado,
    idPresupuesto,
    fechaDesde,
    fechaHasta,
    idEstadoPresupuesto,
    rolIngresoAutorizaciones,
    idSeccional,
    idBandeja,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacion
  ) => {
    return fetchConToken(
      `Presupuestos/traerGestion?${armarParametrosPresupuestos(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
        idEstadoPresupuesto,
        rolIngresoAutorizaciones,
        idSeccional,
        idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion
      )}`
    );
  },
  getContadoresPresupuestosGestion: (
    idAfiliado,
    idPresupuesto,
    fechaDesde,
    fechaHasta,
    idEstadoPresupuesto,
    rolIngresoAutorizaciones,
    idSeccional,
    idBandeja,
    idPrestador,
    idCartillaPrestador,
    idEfectorFacturacion) => {
    return fetchConToken(
      `Presupuestos/traerContadoresGestionUsuario?${armarParametrosPresupuestos(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
        idEstadoPresupuesto,
        rolIngresoAutorizaciones,
        idSeccional,
        idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion
      )}`
    );
  },
  postPresupuesto: (data) => {
    return fetchConToken(`Presupuestos`, data, "POST");
  },
  putPresupuesto: (data) => {
    return fetchConToken(`Presupuestos`, data, "PUT");
  },
  putEstadoPresupuesto: (data) => {
    return fetchConToken(`Presupuestos/modificarEstado`, data, "PUT");
  },
  postPracticasPresupuesto: (practicas) => {
    return fetchConToken(`PracticaPresupuesto`, practicas, "POST");
  },
  postEnviarPresupuesto: (idPresupuesto, urgente) => {
    return fetchConToken(
      `Presupuestos/enviar/${idPresupuesto}/${urgente}`,
      {},
      "POST"
    );
  },
  // SEGUIMIENTO
  getSeguimiento: (idSolicitud) => {
    return fetchConToken(`SeguimientoSolicitudes/traerPorSolicitud/${idSolicitud}`);
  },
  ingresarSeguimiento: (data, method) => {
    return fetchConToken(`SeguimientoSolicitudes`, data, method);
  },
  deleteSeguimiento: (data) => {
    return fetchConToken(`SeguimientoSolicitudes`, data, "DELETE");
  },
  uploadSeguimiento: (data) => {
    return fetchConToken(`SeguimientoSolicitudes`, data, "POST");
  },

  //SOLICITUDES TOMADAS
  getSolicitudesTomadasPorUsuario: () => {
    return fetchConToken(`SolicitudesTomadas/traerPorUsuario`);
  },
  getSolicitudesTomadas: () => {
    return fetchConToken(`SolicitudesTomadas/traerTomadas`);
  },
  putLiberarSolicitud: (id) => {
    return fetchConToken(`SolicitudesTomadas`, { id }, "PUT");
  },
  postTomarSolicitud: (idSolicitud) => {
    return fetchConToken(`SolicitudesTomadas`, { idSolicitud }, "POST");
  },

  // PRESUPUESTOS TOMADOS
  getPresupuestosTomadosPorUsuario: () => {
    return fetchConToken(`PresupuestosTomados/traerPorUsuario`);
  },
  getPresupuestosTomados: () => {
    return fetchConToken(`PresupuestosTomados/traerTomados`);
  },
  putLiberarPresupuesto: (id) => {
    return fetchConToken(`PresupuestosTomados`, { id }, "PUT");
  },
  postTomarPresupuesto: (idPresupuesto) => {
    return fetchConToken(`PresupuestosTomados`, { idPresupuesto }, "POST");
  },

  getSolicitudesPendientesPorAfiliado: (idAfiliado) => {
    return fetchConToken(`Solicitudes/traerPendientesPorAfiliado/${idAfiliado}`)
  },
  getEmpadronamientoSolicitud: (idSolicitud) => {
    return fetchConToken(`Solicitudes/traerEmpadronamientoSolicitud/${idSolicitud}`);
  },
  imprimirSolicitud: (idSolicitud, idEstadoSolicitud, periodo, sinMateriales = true) => {
    return fetchConToken(`Solicitudes/generarPDF/${idSolicitud}/${idEstadoSolicitud}/${periodo}/${sinMateriales}`);
  },
  enviarSolicitud: (idSolicitud, periodo) => {
    return fetchConToken(`Solicitudes/enviarPDF/${idSolicitud}/${periodo}`);
  },
  //BUSCADOR SOLICITUDES
  getBuscadorSolicitudes: (
    idAfiliado,
    idSolicitud,
    fechaDesde,
    fechaHasta,
  ) => {
    return fetchConToken(
      `Solicitudes/buscadorSolicitud?${armarParametrosBuscadorAutorizaciones(
        idAfiliado,
        fechaDesde,
        fechaHasta,
        idSolicitud,
      )}`
    );
  },
  getdatosModificacionInternacion: (
    idAfiliado,
    idSolicitud,
  ) => {
    return fetchConToken(
      `Solicitudes/datosModificacionInternacion?${armarParametrosDatosModificacionInternacion(
        idAfiliado,
        idSolicitud,
      )}`
    );
  },
  getdatosAfiliadosRecupero: (
    idAfiliado
  ) => {
    return fetchConToken(
      `Solicitudes/afiliadosRecupero?${armarParametrosDatosModificacionInternacion(
        idAfiliado,
      )}`
    );
  },
  getdatosAfiliadosRecuperoAutorizador: (
    idAfiliado
  ) => {
    return fetchConToken(
      `Solicitudes/afiliadosRecuperoAutorizacion?${armarParametrosDatosModificacionInternacion(
        idAfiliado,
      )}`
    );
  },
  getBuscadorPresupuestos: (
    idAfiliado,
    idPresupuesto,
    fechaDesde,
    fechaHasta,
  ) => {
    return fetchConToken(
      `Presupuestos/buscadorPresupuesto?${armarParametrosBuscadorPresupuestos(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
      )}`
    );
  },
  putModificarInternacion: (data) => {
    return fetchConToken(`Solicitudes/ModificarInternacion`, data, "PUT");
  },
  postAfiliadoRecupero: (data) => {
    return fetchConToken(`Solicitudes/afiliadosRecupero`, data, "POST");
  },
  putAfiliadoRecupero: (data) => {
    return fetchConToken(`Solicitudes/afiliadosRecupero`, data, "PUT");
  },
  deleteAfiliadoRecupero: (data) => {
    return fetchConToken(`Solicitudes/afiliadosRecupero`, data, "DELETE");
  },
};



export default AutorizacionesService;
